import React from "react";

export const TermsOfUse: React.FC = () => {

    // set document title:
    document.title = "Policies | ipwd.club";

    return (
        <div style={{textAlign: "left", maxWidth: "800px"}}>
            <h1>Terms of Service</h1>
            <p>
                Last updated: January 27, 2026
            </p>
            <h4><a href="#1">Introduction</a></h4>
            <p>
                We ("iplaywithdolls", "ipwd.club", "the website") grant eligible users access to the website, subject the following terms:
            </p>
            <h4><a href="#1">Adult Content</a></h4>
            <p>
                This website contains explicit adult content. By using this website, you acknowledge and accept that you may be exposed to adult material and agree to view such content at your own risk.
            </p>
            <p>
                This website is intended solely for users who are 18 years of age or older, or the legal age of majority in your jurisdiction. By accessing and using this website, you confirm that you are at least 18 years old or the legal age of majority in your jurisdiction.
            </p>
            <h4><a href="#3">Patreon Account Linking</a></h4>
            <p>
                Access to the website is granted exclusively through linking your Patreon account.
            </p>
            <p>
                By linking your Patreon account, you authorize the website to verify your Patreon membership and agree to abide by these Terms of Use as well as any additional policies provided on the site.
            </p>
            <h4><a href="#4">Account Deletion</a></h4>
            <p>
                You have the right to delete your account at any time.
            </p>
            <p>
                Upon deletion, the website will remove your personal information from our systems.
            </p>
            <h4><a href="#5">Modifications to Terms</a></h4>
            <p>
                We reserve the right to modify these Terms of Use at any time.
            </p>
            <p>
                Any changes will be posted on the website, and your continued use of the site will constitute acceptance of the updated terms.
            </p>
            <h4><a href="#6">Disclaimer and Limitation of Liability</a></h4>
            <p>
                The website is provided on an "as is" basis without any warranties, express or implied.
            </p>
            <p>
                In no event shall the website or its owners be liable for any direct, indirect, incidental, or consequential damages arising from your use of the site.
            </p>
            
            <h1>Privacy Policy</h1>
            <p>
                Last updated: January 27, 2026
            </p>
            <h4><a href="#2">Information We Collect</a></h4>
            <p>
                When you link your Patreon account to our website, we receive personal information provided by Patreon, which may include your email address, membership status with our campaign, and other profile details. We also receive information via "web-hooks" from Patreon when your membership status changes.
            </p>
            <p>
                We do not collect additional personal data beyond what is provided via the Patreon authentication and web-hook processes.
            </p>
            <p>
                Your personal information is used to verify your identity, grant you access to the website, and manage your account. We do not sell or share your personal information with third parties.
            </p>
            <h4><a href="#6">Security</a></h4>
            <p>
                We implement appropriate technical measures to secure your personal information.
            </p>
            <p>
                Despite our efforts, no transmission over the Internet is completely secure, and we cannot guarantee absolute security.
            </p>
            <h4><a href="#7">Changes to This Privacy Policy</a></h4>
            <p>
                We may update this Privacy Policy from time to time.
            </p>
            <p>
                Any changes will be posted on the website, and your continued use of the site signifies your acceptance of the revised policy.
            </p>
            <h4><a href="#8">Contact Us</a></h4>
            <p>
                If you have any questions or concerns about our policies, please contact us at: <a href="mailto:admin@ipwd.club">admin@ipwd.club</a>
            </p>
        </div>
    );
}
